export const SESSION_PRIMARY_TENANT = "https://www.cappelendamm.no" as const;
